var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticStyle:{"border":"1px solid #d7d7d7"},attrs:{"dense":"","flat":""}},[_vm._t("toolbar")],2),_c('div',{attrs:{"id":"document"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }